import { usePwaStore } from '@diamond/sol-buyer-context';
import { useEffect } from 'react';

export function usePwaNetworkStatus(isEnabled: boolean) {
  const setIsPwaOffline = usePwaStore((state) => state.setIsPwaOffline);

  useEffect(() => {
    if (!isEnabled) {
      setIsPwaOffline(false);
      return;
    }

    const handleOnline = () => setIsPwaOffline(false);
    const handleOffline = () => setIsPwaOffline(true);

    setIsPwaOffline(!navigator.onLine);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [isEnabled, setIsPwaOffline]);
}
